import React from 'react';
import './MatchCard.css';

const MatchCard = ({ match, round, onPlayerClick, onMatchClick }) => {

  const handleCardClick = (e) => {
    // Only trigger match click if clicking on the card itself, not on players
    if (e.target.closest('.player-card')) {
      return; // Let player click handler take over
    }
    if (onMatchClick) {
      onMatchClick(match);
    }
  };

  // Safety check - ensure match has players
  if (!match || !match.player1 || !match.player2) {
    return null;
  }

  const isPotential = match.isPotential === true;
  const player1IsPlaceholder = match.player1?.isPlaceholder === true;
  const player2IsPlaceholder = match.player2?.isPlaceholder === true;

  return (
    <div className={`match-card ${isPotential ? 'potential-match' : ''}`} onClick={handleCardClick}>
      <div className="match-header">
        <span className="match-id">Match {match.id}</span>
        {isPotential && <span className="potential-badge">Potential</span>}
        {match.score && (
          <span className="match-score">{match.score}</span>
        )}
      </div>
      
      <div className="players-container">
        {/* Player 1 */}
        <div
          className={`player-card ${match.player1.isHome !== false ? 'home' : 'away'} ${match.winner === 1 ? 'winner' : ''}`}
          onClick={(e) => {
            e.stopPropagation();
            onPlayerClick && onPlayerClick(match.player1, match, round, 1);
          }}
        >
          <div className="player-badge">
            {match.player1.isHome !== false && <span className="home-badge">HOME</span>}
          </div>
          <div className="player-image-container">
            {!player1IsPlaceholder ? (
              <img 
                src={match.player1.image || '/images/test.jpeg'} 
                alt={match.player1.name}
                className="player-image"
                onError={(e) => {
                  e.target.src = '/images/test.jpeg';
                }}
              />
            ) : (
              <div className="player-image placeholder-image">?</div>
            )}
          </div>
          <div className={`player-name ${player1IsPlaceholder ? 'placeholder-name' : ''}`}>
            {match.player1.name}
          </div>
          {match.winner === 1 && <div className="winner-indicator">✓</div>}
        </div>

        <div className="vs-divider">
          <span>VS</span>
        </div>

        {/* Player 2 */}
        <div
          className={`player-card ${match.player2.isHome !== false ? 'home' : 'away'} ${match.winner === 2 ? 'winner' : ''}`}
          onClick={(e) => {
            e.stopPropagation();
            onPlayerClick && onPlayerClick(match.player2, match, round, 2);
          }}
        >
          <div className="player-badge">
            {match.player2.isHome !== false && <span className="home-badge">HOME</span>}
          </div>
          <div className="player-image-container">
            {!player2IsPlaceholder ? (
              <img 
                src={match.player2.image || '/images/test.jpeg'} 
                alt={match.player2.name}
                className="player-image"
                onError={(e) => {
                  e.target.src = '/images/test.jpeg';
                }}
              />
            ) : (
              <div className="player-image placeholder-image">?</div>
            )}
          </div>
          <div className={`player-name ${player2IsPlaceholder ? 'placeholder-name' : ''}`}>
            {match.player2.name}
          </div>
          {match.winner === 2 && <div className="winner-indicator">✓</div>}
        </div>
      </div>
    </div>
  );
};

export default MatchCard;
